import { StyleSheet, Text, View } from 'react-native';

import { Checkbox } from './checkbox';
import { useCuisines, type Cuisine } from './hooks';

export const Demo = () => {
  const { cuisines, toggleCuisine } = useCuisines();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>What are your favourite cuisines?</Text>
      <View style={styles.listContainer}>
        {cuisines.map((cuisine: Cuisine) => (
          <Checkbox
            key={cuisine.id}
            label={cuisine.name}
            checked={cuisine.selected}
            onPress={() => toggleCuisine(cuisine.id)}
          />
        ))}
      </View>
    </View>
  );
};

export const StaticDemo = () => {
  const { cuisines, toggleCuisine } = useCuisines();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>What are your favourite cuisines?</Text>
      <View style={styles.listContainer}>
        {cuisines.map((cuisine: Cuisine) => (
          <Checkbox
            key={cuisine.id}
            label={cuisine.name}
            checked={cuisine.selected}
            onPress={() => toggleCuisine(cuisine.id)}
            disableAnimations
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#0d0d0d',
    borderWidth: 1,
    borderColor: '#777777',
    padding: 24,
    marginBottom: 24,
    borderRadius: 16,
    borderCurve: 'continuous',
  },
  title: {
    color: '#fff',
    fontSize: 26,
    marginBottom: 24,
  },
  listContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
});
